import PropTypes from 'prop-types';
import classNames from 'classnames';

const ClearSelections = ({ onClick, allOptionsSelected }) => {
  const clearAllClass = () => classNames({
    'px-2.5 py-0 pb-1 text-right block text-sm text-action-blue font-medium-font': true,
    'border-b border-light-border-blue border-solid': !allOptionsSelected,
  });

  return (
    <div className={clearAllClass()}>
      <a
        role="button"
        onClick={onClick}
        tabIndex={0}
      >
        Clear All
      </a>
    </div>
  );
};

ClearSelections.propTypes = {
  allOptionsSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ClearSelections;
